import client from "./client";
import { User } from "@lab/types/users";
import { DailyDataToken } from "@lab/types/tokens";

const fetch = async (user: User): Promise<DailyDataToken[] | undefined> => {
	const { id } = user;
	const response = await client.get(`/users/${id}/tokens`);
	return response.data as DailyDataToken[];
};

const create = async (user: User): Promise<DailyDataToken | undefined> => {
	const { id } = user;
	const response = await client.post(`/users/${id}/token`);
	return response.data as DailyDataToken;
};
const revoke = async (
	userid: number,
	tokenid: number
): Promise<undefined | undefined> => {
	if (!tokenid || !userid) return undefined;
	const response = await client.delete(`/users/${userid}/token/${tokenid}`);
	return response.data as undefined;
};
const update = async (
	token: DailyDataToken
): Promise<DailyDataToken | undefined> => {
	const { userid, id } = token;
	const response = await client.put(`/users/${userid}/token/${id}`, token);
	return response.data as undefined;
};

export { fetch, create, revoke, update };
